import { useEffect } from "react";
import {
  Box,
  Divider,
  Theme,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useFormikContext } from "formik";

import useCatalogDetail from "hooks/useCatalogDetail";
import { colors } from "theme";
import { Workflow } from "types/design";
import { ICustomPanelForm } from "types/form";

import CustomTable from "./CustomTable";
import SearchTargetDropdown from "./SearchTargetDropdown";

const useStyles = makeStyles(() => ({
  divider: {
    color: colors.grey[400],
  },
  subheader: {
    fontSize: 14,
    lineHeight: 1.5,
    letterSpacing: 0.1,
    color: colors.nero[300],
    marginTop: 8,
  },
}));

const FindModule = ({ workflow }: { workflow: Workflow }) => {
  const { newDetails } = useCatalogDetail();
  const classes = useStyles();
  const { validateForm } = useFormikContext<ICustomPanelForm>();

  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('sm')
  );

  useEffect(() => validateForm() as any, [newDetails, validateForm]);

  return (
    <Box>
      <Typography component="h2" variant={isMobile ? "h4" : "h2"}>
        Designs
      </Typography>
      <Box p={2} mt={3} bgcolor="#FFF">
        <Box width={isMobile ? 1 : 0.5} mb={3} position="relative">
          <SearchTargetDropdown />
        </Box>
        <Divider className={classes.divider} />
        <CustomTable workflow={workflow} />
      </Box>
    </Box>
  );
};

export default FindModule;
